import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getStorage } from "@/utils/storage";

Vue.use(VueI18n);
const { language = 'zh-CN' } = getStorage('vuex') || {};

export default new VueI18n({
  locale: language,
  messages: {
    'zh-CN': require('./lang/zh-CN.json'),
    'en-US': require('./lang/en-US.json'),
  },
});
